import './products.scss'
import { Product, ProductsProps } from '../../interface/interfaces'
import ProductsSkeleton from '../SkeletonLoaders/ProductsSkeleton';
import { AnimatePresence, motion } from 'framer-motion';
import ProductCard from '../ProductCard/ProductCard';
import { NavLink } from 'react-router-dom';
import { ShoppingCartIcon } from 'lucide-react';

interface Props extends ProductsProps {
  isLoading: boolean,
  setProducts: React.Dispatch<React.SetStateAction<Product[]>>,
  showFull?:boolean,
  fullUrl?:string
}

const Products = ({ title, products, isLoading ,setProducts,showFull=false,fullUrl }: Props) => {

  const setProduct=(product_data:Product)=>{
     // Put new product data in products
     setProducts((prev)=>{
         let arr=[...prev]

         let newArr=arr.map((data)=>{
             return data.productId === product_data.productId ? product_data : data
         })
         
         return newArr
     })

  }
  
  return (
    <div className="products">
      
      <div className='tFlex'>
        <div className='title'>{title}</div>

        {!showFull && (
        <NavLink to={fullUrl || ''}><div className='vAll'>View All</div></NavLink>
        )}

      </div>
      

      <AnimatePresence mode="wait">
        {isLoading && (
          <motion.div initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }}
            exit={{ opacity: 0 }}>
            <ProductsSkeleton number={5}></ProductsSkeleton>
          </motion.div>
        )}

        {!isLoading && (
          <>

              <motion.div className='productsCont' initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }}
          exit={{ opacity: 0 }}>

          {products.map((data, index) => (

           <ProductCard data={data} setProduct={setProduct} index={index} ></ProductCard>

          ))}


            

        </motion.div>


          {products.length < 1 && (
                <div className='emptycart'>
                  <div className='idiv'>
                    <ShoppingCartIcon size={70} strokeWidth={1.5} className='bigcart'></ShoppingCartIcon>
                    <div className='text'>No products found</div>
                  </div>
                </div>
              )}
          </>
      )}
      </AnimatePresence>




    </div>
  )
}

export default Products;